import { POST_LOGIN_REDIRECT_KEY } from '../../constants';
import { markPostLoginRedirect } from '../../utils/getIsFromItemExternalUrl';

/**
 * Returns a safe in-app path (pathname + search) to open after login, or null.
 * Clears storage when a value is returned.
 */
export const consumePostLoginRedirect = (): string | null => {
  const raw = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  if (!raw) {
    return null;
  }

  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);

  if (!raw.startsWith('/') || raw.startsWith('//')) {
    return null;
  }

  // The redirect resumes the pre-login cold start — external-url detection
  // must treat its target as the initially opened pathname.
  markPostLoginRedirect(raw.split('?')[0]);

  return raw;
};
